import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { publicApi } from "@/lib/api";
import { ArrowLeft, Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await publicApi.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("Sprawdź skrzynkę e-mail");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Błąd");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <header className="border-b-2 border-[#0F172A] bg-white">
        <div className="max-w-6xl mx-auto px-6 py-4">
          <Link to="/teacher/login" className="flex items-center gap-2 font-bold">
            <ArrowLeft className="w-4 h-4" strokeWidth={2.5} /><span>Wróć do logowania</span>
          </Link>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          {done ? (
            <div className="brut bg-white rounded-md p-8 text-center" data-testid="forgot-success">
              <div className="brut bg-[#D1FAE5] w-16 h-16 rounded-md flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-8 h-8" strokeWidth={2.5} />
              </div>
              <h1 className="font-display font-black text-2xl mb-3">Sprawdź e-mail</h1>
              <p className="text-[#334155]">
                Jeśli konto z adresem <b>{email}</b> istnieje, wysłaliśmy link
                resetujący hasło. Link wygasa za 1 godzinę.
              </p>
            </div>
          ) : (
            <>
              <h1 className="font-display font-black text-4xl mb-2">Reset hasła</h1>
              <p className="text-[#334155] mb-8">
                Podaj swój adres e-mail. Wyślemy link do ustawienia nowego hasła.
              </p>
              <form onSubmit={submit} className="brut bg-white rounded-md p-6 space-y-4">
                <div>
                  <Label className="font-bold text-sm">Adres e-mail</Label>
                  <Input
                    type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                    className="mt-2 brut-input border-2 border-[#0F172A] rounded-md h-12"
                    placeholder="nauczyciel@example.pl" autoFocus
                    data-testid="forgot-email-input"
                  />
                </div>
                <Button
                  type="submit" disabled={loading}
                  className="w-full brut brut-hover bg-[#0F172A] hover:bg-[#0F172A] text-white font-bold rounded-md h-12"
                  data-testid="forgot-submit-btn"
                >
                  <Mail className="w-4 h-4 mr-2" strokeWidth={2.5} />
                  {loading ? "Wysyłam..." : "Wyślij link resetujący"}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
